var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-family"},[_c('div',{staticClass:"menu-title",on:{"click":function($event){$event.stopPropagation();return _vm.showFontFamilyPopup($event)}}},[_c('span',[_vm._v(_vm._s(_vm.currentFont.label || '方正黑体'))]),_vm._v(" "),_c('i',{staticClass:"tri"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5172da06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subtitle/subtitlePanel/fontFamily.vue
// module id = null
// module chunks = 